import { PortalContractResponse } from "../../features/portal/contracts/PortalContractResponse";
import { ContractStatus } from "../../features/contracts/models/ContractStatus";
import { ContractType } from "../../features/contracts/models/ContractType";

/** What a Cancelled — charged date costs a member who is not billed per Visit. */
export type ChargedVisitShape = "pack" | "subscription";

const coversDate = (contract: PortalContractResponse, date: string): boolean =>
  contract.status === ContractStatus.Active &&
  contract.validFrom <= date &&
  (contract.validUntil == null || date <= contract.validUntil);

/**
 * The billing shape behind a charged cancellation, read from the member's contracts the
 * portal already loaded (no money math): an Active pack covering the date wins, like
 * auto-settle; otherwise an Active subscription covering it. Null when neither applies.
 */
export const chargedVisitShape = (
  date: string,
  contracts: PortalContractResponse[] | undefined,
): ChargedVisitShape | null => {
  const covering = (contracts ?? []).filter((c) => coversDate(c, date));
  if (covering.some((c) => c.type === ContractType.VisitPack)) return "pack";
  if (
    covering.some(
      (c) => c.type === ContractType.FlexibleSubscription || c.type === ContractType.FlatSubscription,
    )
  ) {
    return "subscription";
  }
  return null;
};
